import React from "react";

const Java_floor = () => {
  return (
    <div>
      <h1>Java floor</h1>
      <p>This page provides explanations, examples, and common use-cases for Java floor in Java.</p>
    </div>
  );
};

export default Java_floor;
